import React from 'react'
import { trackECommerceEvent } from '~/tools/analytics/googleAnalytics'
import Spinner from '~/components/Spinner'
import getQueryVariable from '~/tools/getQueryVariable'
import popup from '~/views/Popup/popup'
import { trackEvent } from '~/tools/analytics/cleverTap'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'
import includes from 'lodash/includes'

import './style.css'
import { successIcon, failureIcon } from '~/components/JusPay/paymenticons';
import { getLocalizedVal } from '~/tools/localization/helpers';

class Notice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      paymentHandler: null,
      loading: true
    }
  }

  componentDidMount() {
    this.dataLayer = window.dataLayer || { push: _ => { } }
    this.interval = setInterval(() => this.refresh(), 500)
    getCountryCode().then(country => {
      if (window.settings.paymentProviders && window.settings.paymentProviders.juspay && window.settings.paymentProviders.juspay.country === country) { // When JusPay enabled

        return this.setState({ paymentHandler: 'juspay' });

      } else { // When JusPay is not enabled then Either ccavenue or SSL or Strip will run
        var providers = window.settings.paymentProviders
        for (var k in providers) {
          if (includes(providers[k].country, country)) {

            return this.setState({ paymentHandler: k })
          }
        }
        for (k in providers) {
          if (includes(providers[k].country, 'ROW')) {

            return this.setState({ paymentHandler: k })
          }
        }

        return this.setState({ paymentHandler: 'stripe' })
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState !== this.state && this.state.paymentHandler) { this.trackCT(prevProps, prevState) }
  }

  trackCT = () => {
    const subscriptionInfo = JSON.parse(localStorage.getItem('planDetails'))
    const userInfo = JSON.parse(localStorage.getItem('user'))
    let pageType = document.location.pathname;
    pageType = pageType.substr(1);
    var initiateSubscriptionEventData = {
      userId: userInfo.user.userId,
      planId: subscriptionInfo.id,
      paymentHandler: this.state.paymentHandler,
      platform: 'Web',
      transactionAmount: subscriptionInfo.planDetails[0].recurringPaymentAmount,
      pageType: pageType
    }

    let message = '';
    let eventName = '';
    const title = decodeURIComponent(getQueryVariable('title'))
    if (title.includes('Thank')) {
      message = 'Subscription Plan Status Success';
      eventName = 'SUBSCRIPTION_COMPLETED';
    } else if (title.includes('Subscription')) {
      message = 'Subscription Plan Status Failure';
      eventName = 'SUBSCRIPTION_FAILURE';

    }

    if (!this.state.loading && this.state.paymentHandler) {
      trackEvent(message, initiateSubscriptionEventData)
      trackEvent(eventName, initiateSubscriptionEventData)

    }
  }
  refresh() {
    if (this.dataLayer) {
      clearInterval(this.interval)
      this.setState({ loading: false })
      this.sendEvents()
    }
  }

  sendEvents() {
    const title = decodeURIComponent(getQueryVariable('title'))
    if (title.includes('Thank')) {
      const ga = window.ga;
      const dataLayer = this.dataLayer || { push: _ => { } }
      const subscriptionInfo = JSON.parse(localStorage.getItem('planDetails'))
      const userInfo = JSON.parse(localStorage.getItem('user'))
      ga("ec:setAction", "checkout", { 'step': 3 })
      trackECommerceEvent('ec:addProduct', {
        id: subscriptionInfo.id ? subscriptionInfo.id : '',
        name: subscriptionInfo.name,
        price: subscriptionInfo.planDetails[0].recurringPaymentAmount,
        quantity: 1
      })
      ga("send", "event", "e-commerce", "checkout", "3")
      ga("ec:setAction", "purchase", {
        revenue: subscriptionInfo.planDetails[0].recurringPaymentAmount,
        id: `${userInfo.user.userId} - ${Date.now()}`
      })
      trackECommerceEvent('ec:addProduct', {
        id: subscriptionInfo.id ? subscriptionInfo.id : '',
        name: subscriptionInfo.name,
        price: subscriptionInfo.planDetails[0].recurringPaymentAmount,
        quantity: 1
      })
      ga('set', 'currencyCode', subscriptionInfo.planDetails[0].recurringPaymentCurrencyCode)
      ga('send', 'event', 'e-commerce', 'purchase')
      dataLayer.push({
        "event": "finish_subscription",
        "plan_currency_code": subscriptionInfo.planDetails[0].recurringPaymentCurrencyCode,
        "plan_uuid": subscriptionInfo.id ? (subscriptionInfo.id) : '',
        "plan_name": subscriptionInfo.name,
        "plan_price": subscriptionInfo.planDetails[0].recurringPaymentAmount,
        "transaction_id": `${userInfo.user.userId} - ${Date.now()}`
      })
    }

    if (title.includes('Thank') || title.includes('Subscription') || title.includes('Pending')) {
      setTimeout(() => {
        popup.hide();
        
        if(title.includes('Thank'))
          window.location.href = '/'
        else 
          window.location.href = window.location.origin + window.location.pathname; // use this way for not adding parameter in url
        
         return false;
      }, 5000);
    }
  }

  render() {
    var title = decodeURIComponent(getQueryVariable('title'))
    var message = decodeURIComponent(getQueryVariable('message'))
    let imgIcon, classIcon;

    if (title.includes('Thank')) {

      imgIcon = successIcon;
      classIcon = "icon-success";

    } else if (title.includes('Pending')) {

      imgIcon = '';
      classIcon = "icon-fail";

    } else if (title.includes('Subscription')) {

      imgIcon = failureIcon;
      classIcon = "icon-fail";

    } else {

      imgIcon = '';
      classIcon = "";

    }

    const loadingMessage = getLocalizedVal(window.settings, 'genericMessages', 'loadingMessage') || 'Your transaction is being processed. Please do not refresh or close the page';

    return (
      <div className="notice-popup centered padded">
        {
          this.state.loading ? <div className="loading centered">
            <div className="loading-message"> {loadingMessage} </div>
            <Spinner />
          </div>
            :
            <div>
              {imgIcon && <img className={classIcon} src={imgIcon} />}
              {(title === 'Pending') ? '' : <div className="title"> {title} !!!</div>}
              <div className="message">{message}</div>
            </div>
        }
      </div>
    )
  }
}

export default Notice;
